export default "__VITE_ASSET__TLQ3pebA__"